export const MAX_EXPERIENCE_SELECT = 3;

export const SPONSORSHIP_PROGRAM_OPTIONS = [
  { value: "bronze", label: "Bronze ($1,000–4,999)" },
  { value: "silver", label: "Silver ($5,000–14,999)" },
  { value: "gold", label: "Gold ($15,000–24,999)" },
  { value: "platinum", label: "Platinum ($25,000+)" },
];

export const INVESTOR_TYPE_OPTIONS = [
  { value: "angel_investor", label: "Angel Investor", hint: "Individual deploying personal capital" },
  { value: "venture_capital", label: "Venture Capital (VC)", hint: "Institutional fund managing LP capital" },
  { value: "family_office", label: "Family Office", hint: "Private wealth management entity" },
  { value: "cvc", label: "Corporate Venture Capital (CVC)", hint: "" },
  { value: "private_equity", label: "Private Equity (PE)", hint: "Growth stage / Buyout focus" },
  { value: "impact_investor", label: "Impact Investor", hint: "Focused on social/environmental ROI" },
  { value: "incubator_accelerator", label: "Incubator / Accelerator", hint: "Early-stage support and funding" },
];

export const FUND_SIZE_RANGE_OPTIONS = [
  { value: "$100M–$500M", label: "$100M–$500M" },
];

export const STAGE_FOCUS_OPTIONS = [
  { value: "MVP", label: "MVP" },
  { value: "Pre-Seed", label: "Pre-Seed" },
];

export const DOMAIN_FOCUS_OPTIONS = [
  { value: "SaaS", label: "SaaS" },
  { value: "AI", label: "AI" },
];

export const MINIMUM_TRACTION_OPTIONS = [
  { value: "MVP Built", label: "MVP Built" },
];

export const MANDATORY_PITCH_MATERIAL_OPTIONS = [
  { value: "Pitch Deck", label: "Pitch Deck" },
];

export const privacyPolicyContent = `Privacy Policy

This Privacy Policy describes the types of information IgniteNext collects from users of the IgniteNext platform and associated services (the "Service"), how such information is used, and the circumstances under which it may be disclosed.

1. Information We Collect: We collect information to operate the Service, facilitate mentorship matching, track progress, and improve the platform.

1.1 Information You Provide Directly:
Account Data: Includes your name, email address, password, user type (Student, Mentor, Partner), and demographic information such as location, educational status, or industry background.
Student/Founder Data: Includes project ideas, pitch summaries, progress notes, and performance metrics submitted during the 5-Stage Innovator Path.
Mentor Data: Includes professional biography, industry experience, advising philosophy, and availability.
Communication Data: Includes records of interactions with IgniteNext or between users via the platform's chat or messaging features.

1.2 Information Collected Automatically (Usage Data): When you use the Service, we may automatically collect certain information about your device and interactions to help operate, maintain, and improve the platform. This includes:
Technical Data: Such as your IP address, browser type, device information, operating system, and unique device identifiers.
Activity Data: Includes pages viewed, features used, time spent on the Service, and interaction patterns, which help us enhance the workflow engine and overall user experience.

2. How We Use Your Information: We use the information we collect for the following purposes:
Service Provision: To operate, maintain, and provide the features and functionality of the Service.
Matching and Engagement: To effectively match Student teams with Catalyst Mentors and facilitate communication between parties.
Program Assessment: To track Student progress through the 5-Stage Path, evaluate venture viability, and measure program effectiveness.
Communication: To send you program updates, alerts, system notifications, and relevant information about the IgniteNext community.
Improvement: To analyze usage trends and enhance the platform, tools, and mentor resources.
Promotion: To showcase successful ventures and Mentor contributions, and program achievements.

3. SMS and Mobile Communication: If you provide your mobile number, you consent to receive automated and pre-recorded text messages from IgniteNext.
Non-Sharing Disclosure: No mobile information will be shared with third parties / affiliates for marketing/promotional purposes. All the above categories exclude text messaging originator opt-in data and consent; this information will not be shared with any third parties.
Opt-Out: You can opt-out of SMS communications at any time by updating your profile.

4. How We Share Your Information: We share your information only in specific, necessary contexts:

4.1 With Other Users (Internal Sharing):
Students and Mentors: Contact information (name, email) and professional profiles are shared between matched Mentors and Students to facilitate communication and collaboration.
Review Panels and Investors: Project summaries, pitch decks, and performance metrics may be shared with authorized Review Panels, Partners, and Investors for the purpose of evaluation, funding, and support opportunities.

4.2 Legal Requirements: We may disclose your information if required to do so by law or in the good faith belief that such action is necessary to comply with legal obligations, protect the rights or property of IgniteNext, or protect the safety of our users or the public.

5. Data Security: We implement commercially reasonable security measures to protect your information from unauthorized access, use, or disclosure. However, no internet transmission or electronic storage is completely secure, so we cannot guarantee absolute security.

6. Your Choices and Rights

6.1 Access and Update: You may access and update your account information and preferences directly through your account settings on the Service.

6.2 Deletion: You have the right to request deletion of your account and associated personal data. Please contact us at the email below.

7. Changes to This Policy
We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Policy on this page and updating the "Last Updated" date. We encourage you to review this Policy periodically.

8. Contact Information
If you have any questions or concerns about this Privacy Policy, please contact us at:
Email: Contactus@IgniteNext.com`;

export const termsConditionsContent = `Terms & Conditions
Last Updated: February 23, 2026

Welcome to IgniteNext. These Terms & Conditions ("Terms") govern your access to and use of the IgniteNext website, program contents, mentorship services, and all associated services (collectively, the "Service").

By accessing or using the Service, you agree to be bound by these Terms.

1. Eligibility and User Types
We recognize three primary user types:

Students: Individuals or teams developing a venture through the 5-Stage Innovator Path.
Catalyst Mentors: Experienced professionals providing structured guidance and support
Partners/Investors: Organizations or individuals offering resources, funding, or ecosystem support.
2. User Accounts and Conduct
2.1 Account Creation
You agree to provide accurate, current, and complete information when creating an account. You are solely responsible for safeguarding your password and for any actions taken using your account credentials.

2.2 Code of Conduct
All users are required to follow a Code of Conduct designed to maintain professionalism, respect, and productive collaboration. The following behaviors are strictly prohibited:

a) Harassment, bullying, discrimination, threats, or any form of abusive behavior.
b) Sharing malicious code, harmful files, explicit materials, or otherwise inappropriate content.
c) Providing false, misleading, or deceptive information regarding identity, expertise, or venture status.
d) Actions that hinder learning, collaboration, or the operation of the IgniteNext ecosystem.
2.3 Advisory Role
Mentorship is for educational and advisory purposes only. Mentors are independent professionals, not employees or agents of IgniteNext. IgniteNext is not liable for outcomes resulting from reliance on Mentor advice. All Mentor–Student interactions must remain professional and within appropriate boundaries at all times.

3. Intellectual Property (IP) and Content Ownership
3.1 Student Ownership
Students and Founders maintain all rights, title, and interest in any Intellectual Property (IP) they develop, including but not limited to ideas, concepts, code, designs, products, services, and related materials. IgniteNext does not acquire any ownership or proprietary interest in such IP through your participation in the program.

3.2 Mentor Contribution (Work-for-Hire)
All Mentors agree that any feedback, suggestions, or contributions made to a Student's project are provided on a "Work-for-Hire" basis. Mentors hereby waive any claim to IP generated by the Students they advise within the Service.

3.3 Non-Compete & Non-Solicitation
Mentors and Partners agree not to use proprietary information disclosed by Students to develop competing products or to solicit Student team members for external ventures without prior written consent from the Student founders.

3.4 Limited License to IgniteNext
You grant IgniteNext a non-exclusive, royalty-free, worldwide license to use, display, reproduce, and distribute your submitted materials (e.g., pitch decks, venture summaries, prototypes, demos) solely for purposes related to program operation, evaluation, promotion, and improvement. This includes, but is not limited to, mentor matching, review panel assessments, internal process development, and public recognition of program achievements.

4. Privacy and Data Protection
4.1 General Confidentiality Agreement (GCA)
By using the Service, all users enter into a mutual confidentiality agreement. You agree not to disclose sensitive information regarding other users' ventures to third parties.

4.2 Data Collection
We collect data necessary for matching and impact analysis. We do not sell personal data to third parties.

4.3 Right to Deletion
Users may request the permanent deletion of their account and associated project data ("Right to be Forgotten"). IgniteNext will process such requests within 30 days, subject to legal record-keeping requirements.

4.4 AI Usage
IgniteNext does not use proprietary student data or business plans to train third-party Artificial Intelligence models.

5. Funding, Micro-Grants, and Disclaimers
All micro-grants, awards, or investment opportunities made available through the Service are discretionary and not guaranteed. Funding decisions rest exclusively with the designated Review Panels, Mentors, and/or independent third-party Investors. IgniteNext makes no representation or warranty regarding the availability, likelihood, or outcome of any funding or venture success.

5.2 Investment Risk
Your interactions or agreements with third-party investors are undertaken entirely at your own risk. IgniteNext is not a broker, dealer, investment advisor, or fiduciary. IgniteNext makes no representations or warranties regarding the appropriateness, legality, financial implications, or potential outcomes of any investment decisions you may make.

6. Termination
IgniteNext may, at its sole discretion, suspend or terminate your account and your access to the Service at any time, with or without prior notice, for violations of these Terms or for any other reason, including inactivity or conduct deemed inappropriate by IgniteNext.

7. Limitation of Liability
7.1 Limitation of Liability
To the fullest extent permitted by applicable law, IgniteNext, its affiliates, officers, directors, employees, and mentors shall not be liable for any indirect, incidental, consequential, special, or punitive damages, or for any loss of profits, revenues, data, use, goodwill, or other intangible losses, whether arising in contract, tort, or otherwise, resulting from:

(a) your access to or use of the Service; or
(b) the actions, advice, or content of any third party, including Mentors, Investors, or other users of the Service.
8. Governing Law and Contact Information
8.1
These Terms and any disputes arising out of or related to your use of the Service shall be governed by, and interpreted in accordance with, the laws of the Commonwealth of Virginia, United States of America, without regard to its conflict of law rules or principles.

9. Contact Information
For any questions, or clarifications regarding these Terms, please contact

Email: Contactus@IgniteNext.com

9. Changes to Terms
We may modify these Terms at any time. Continued use of the Service after changes constitutes acceptance of the modified Terms.

10. Contact Information
For questions about these Terms and Conditions, please contact us at:
Email: Contactus@IgniteNext.com`;
